import { render, staticRenderFns } from "./separator-user-selection-modal.vue?vue&type=template&id=dc0a39b6"
import script from "./separator-user-selection-modal.vue?vue&type=script&lang=js"
export * from "./separator-user-selection-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports